import { Component, OnInit } from '@angular/core';
import { CommonService } from "../../_services/common.service";
import { MatDialog } from "@angular/material";
import { FlashMessagesService } from "angular2-flash-messages";
import { ConfirmationDialogComponent } from "../../shared/confirmation-dialog/confirmation-dialog.component";
import { Router, NavigationEnd } from "@angular/router";
@Component({
  selector: 'app-custome-lineitem-list',
  templateUrl: './custome-lineitem-list.component.html',
  styleUrls: ['./custome-lineitem-list.component.css']
})
export class CustomeLineitemListComponent implements OnInit {
  public idform: any;
  public showForm = false;
  public loading = false;
  public page_header: string = 'Add Line Item';
  public customeLineItemLists: Array<any> = [];
  public customeItemOptions: any = {};
  public total = 0;
  public pagesToShow = 10;
  public page = 1;
  public limit = 10;
  public search: string = "";
  public sortColumnName = "item";
  public sortDirection = "asc";
  public filterCustomeItemText: string;
  public editCustomeItemData: any = {};
  navigationSubscription;

  constructor(private CommonService: CommonService,
    private _flashMessagesService: FlashMessagesService,
    public dialog: MatDialog,
    private router: Router
  ) {
    // override the route reuse strategy
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.navigationSubscription = this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.router.navigated = false;
        window.scrollTo(0, 0);
      }
    });
  }

  ngOnInit() {
    this.getListData();
  }

  toggleForm(loading) {
    if (loading == true) {
      this.editCustomeItemData = {};
      this.getListData();
    }
    this.idform = null;
    this.showForm = !loading;
  }

  formEdit(loading, id) {
    if (loading == true) {
      this.editCustomeItemData = {};
      this.getListData();
    }
    this.idform = id;
    this.showForm = !loading;

  }

  getListData = function () {
    this.loading = true;
    this.customeItemOptions = {
      id: localStorage.getItem("userID"),
      limit: this.limit,
      page: this.page
    };

    if (this.filterCustomeItemText) {
      this.customeItemOptions.search = this.filterCustomeItemText;
    }

    if (this.sortDirection) {
      this.customeItemOptions.orderBy = this.sortColumnName;
      this.customeItemOptions.direction = this.sortDirection;
    }

    this.CommonService.apiService(
      "POST",
      "custom/line/items",
      this.customeItemOptions
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          if (response.data) {
            this.customeLineItemLists = response.data.records;
            this.total = response.data.total;
            this.current_page = response.data.current_page;
            this.limit = response.data.limit;
          }
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  openDialog(id: number): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "250px",
      data: {
        name: "Admin",
        message: "Are you sure you want to delete this Custome Line Item",
        manageData: { id: id }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.id) {
        this.deleteAttribute(result.id);
      }
    });
  }

  deleteAttribute = function (id) {

    let attributeOptions = {
    };
    this.CommonService.apiService(
      "DELETE",
      "custom/line/item/" + id,
      attributeOptions
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.getListData();
          this._flashMessagesService.show("Custome Line Item deleted successfully!", {
            cssClass: "alert-success",
            timeout: 5000
          });

        }
      },
      err => {
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-danger",
          timeout: 5000
        });
      }
    );
  }

  goToPage(n: number): void {
    this.page = n;
    this.getListData();
  }

  onNext(): void {
    this.page++;
    this.getListData();
  }

  onPrev(): void {
    this.page--;
    this.getListData();
  }

  goSort($event) {
    this.sortColumnName = $event.columnName;
    this.sortDirection = $event.sortDirection;
    this.getListData();
  }

  filterCustomeItemType(): void {
    this.page = 1;
    this.total = 0;
    this.getListData();
  }

  clearFilter(): void {
    this.filterCustomeItemText = "";
    this.page = 1;
    this.total = 0;
    this.getListData();
  }

  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-products/custome-lineitem-list/custome-lineitem-list.component.ts